import { TitleBar } from '../../../components';
import TitleUpdater from '../../../components/common/TitleUpdater';
import { CyberModuleCard } from '../components';

const CyberCards = [
  {
    icon: (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="48"
          height="48"
          rx="10"
          fill="#437EF7"
          fill-opacity="0.25"
        />
        <path
          d="M14.25 33H33.75M15.75 15V33M26.25 15V33M32.25 19.5V33M18.75 18.75H19.5M18.75 21.75H19.5M18.75 24.75H19.5M22.5 18.75H23.25M22.5 21.75H23.25M22.5 24.75H23.25M18.75 33V29.625C18.75 29.0037 19.2537 28.5 19.875 28.5H22.125C22.7463 28.5 23.25 29.0037 23.25 29.625V33M15 15H27M26.25 19.5H33M29.25 23.25H29.2575V23.2575H29.25V23.25ZM29.25 26.25H29.2575V26.2575H29.25V26.25ZM29.25 29.25H29.2575V29.2575H29.25V29.25Z"
          stroke="#437EF7"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    title: 'Enterprise Level Applications',
    description:
      'This section is dedicated to mapping and mitigating enterprise level applications and hosting entities.',
    link: '/cyber/enterprise-level/applications',
  },
  {
    icon: (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="48"
          height="48"
          rx="10"
          fill="#437EF7"
          fill-opacity="0.25"
        />
        <path
          d="M25.5 33V25.5C25.5 25.0858 25.8358 24.75 26.25 24.75H29.25C29.6642 24.75 30 25.0858 30 25.5V33M25.5 33H14.3609M25.5 33H30M30 33H33.6391M32.25 33V21.3488M15.75 33V21.349M15.75 21.349C16.8973 22.0122 18.3898 21.853 19.3713 20.8714C19.4159 20.8268 19.4589 20.7811 19.5001 20.7345C20.0498 21.3572 20.854 21.75 21.75 21.75C22.646 21.75 23.4503 21.3572 24 20.7344C24.5497 21.3572 25.354 21.75 26.25 21.75C27.1459 21.75 27.9501 21.3573 28.4998 20.7346C28.541 20.7812 28.5838 20.8268 28.6284 20.8713C29.61 21.853 31.1027 22.0121 32.25 21.3488M15.75 21.349C15.5279 21.2207 15.3187 21.0614 15.1287 20.8714C13.9571 19.6998 13.9571 17.8004 15.1287 16.6288L16.318 15.4395C16.5993 15.1582 16.9808 15.0002 17.3786 15.0002H30.6212C31.019 15.0002 31.4005 15.1582 31.6818 15.4395L32.871 16.6287C34.0426 17.8003 34.0426 19.6998 32.871 20.8713C32.6811 21.0613 32.472 21.2204 32.25 21.3488M18.75 30H22.5C22.9142 30 23.25 29.6642 23.25 29.25V25.5C23.25 25.0858 22.9142 24.75 22.5 24.75H18.75C18.3358 24.75 18 25.0858 18 25.5V29.25C18 29.6642 18.3358 30 18.75 30Z"
          stroke="#437EF7"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    title: 'Location Level Applications',
    description:
      'This section is dedicated to mapping and mitigating location level applications and hosting entities.',
    link: '/cyber/location-level/list',
  },
];

const CyberMenu = () => {
  return (
    <div className="min-h-screen">
      <TitleUpdater title="Cyber" />
      <TitleBar
        title="Cyber Module"
        subtitle="Overview"
        brief="The Cyber Module allows you to quantify the importance of IT applications and related entities to the organization. This can include business functions, locations, and process areas."
      />
      <div className="w-full">
        {CyberCards.map((card) => (
          <CyberModuleCard
            key={card.title}
            icon={card.icon}
            title={card.title}
            description={card.description}
            link={card.link}
            isActive={true}
          />
        ))}
      </div>
    </div>
  );
};

export default CyberMenu;
